import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.054 2.462C11.591 2.152 12.242 2 13 2c1.25 0 2.19.521 2.777 1.368.549.791.723 1.77.723 2.632 0 .65-.12 1.406-.24 2h2.52c2.752 0 4.682 2.715 3.778 5.314l-1.913 5.5a4 4 0 0 1-3.778 2.686H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h3.5c.32 0 .815-.242 1.289-.82C9.25 7.114 9.5 6.455 9.5 6v-.05c0-.48-.002-1.433.418-2.272a2.855 2.855 0 0 1 1.136-1.216Zm2.982 6.27.001-.002.004-.013.014-.053.053-.207c.044-.177.104-.427.163-.711.122-.587.229-1.254.229-1.746 0-.637-.135-1.16-.366-1.493C13.94 4.23 13.63 4 13 4c-.492 0-.779.098-.945.194a.858.858 0 0 0-.348.378c-.19.381-.207.891-.207 1.428 0 1.044-.5 2.135-1.164 2.946-.458.56-1.09 1.1-1.836 1.372V19.5h8.367a2 2 0 0 0 1.89-1.343l1.912-5.5A2 2 0 0 0 18.78 10H15a1 1 0 0 1-.963-1.268ZM6.5 19.5v-9H4v9h2.5Z",
      clipRule: "evenodd"
    }
  )
);
var SvgThumbsUpOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ThumbsUpOutlined_default = SvgThumbsUpOutlined;

export { ThumbsUpOutlined_default as default };
